import Base from "@/services/Base";

export default class Auth extends Base {
    constructor() {
        super();
    }

    login() {
        return this.http.post('/auth/login');
    }
}